import { createReducer } from 'redux-act';

import {
  BOOKING_FETCH_DATA_INIT,
  BOOKING_FETCH_DATA_SUCCESS,
  BOOKING_FETCH_DATA_FAIL,
  BOOKING_DELETE_INIT,
  BOOKING_DELETE_SUCCESS,
  BOOKING_DELETE_FAIL,
  BOOKING_CLEAR_DATA,
  BOOKING_CREATE_INIT,
  BOOKING_CREATE_SUCCESS,
  BOOKING_CREATE_FAIL,
  BOOKING_MODIFY_INIT,
  BOOKING_MODIFY_SUCCESS,
  BOOKING_MODIFY_FAIL,
  BOOKING_CLEAN_UP,
  BOOKING_CLEAR_DATA_LOGOUT
} from '../../actions/bookings';

const initialState = {
  data: [],
  loading: false,
  error: null,
  success: false,
  deleted: false
};

export const bookingsReducer = createReducer(
  {
    [BOOKING_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true
    }),
    [BOOKING_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload.bookings,
      loading: false,
      error: null
    }),
    [BOOKING_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [BOOKING_DELETE_INIT]: state => ({
      ...state,
      loading: true
    }),
    [BOOKING_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.filter(elem => elem.id !== payload.id),
      loading: false,
      error: null,
      deleted: true
    }),
    [BOOKING_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [BOOKING_CLEAR_DATA]: state => ({
      ...initialState,
      data: state.data
    }),
    [BOOKING_CREATE_INIT]: state => ({
      ...state,
      loading: true
    }),
    [BOOKING_CREATE_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.concat(payload),
      loading: false,
      error: null,
      success: true
    }),
    [BOOKING_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [BOOKING_MODIFY_INIT]: state => ({
      ...state,
      loading: true
    }),
    [BOOKING_MODIFY_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.map(elem => {
        if (elem.id === payload.id) {
          return payload;
        }
        return elem;
      }),
      loading: false,
      error: null,
      success: true
    }),
    [BOOKING_MODIFY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [BOOKING_CLEAN_UP]: state => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false
    }),
    [BOOKING_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState
    })
  },
  initialState
);
